/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, TabPanel } from '@coursera/cds-core';

import { CalendarSyncCard } from 'bundles/degree-home/components/v2/Calendar/CalendarSyncCard';
import { RecentGradesCard } from 'bundles/degree-home/components/v2/RecentGrades';
import SlackAccountInfoCard from 'bundles/degree-home/components/v2/SlackAccountInfoCard';
import SupportInfoCard from 'bundles/degree-home/components/v2/SupportInfoCard';
import type { DegreeMetadata } from 'bundles/degree-home/types/Degree';

import { CalendarCard, MobileCalendarCard } from './Calendar';
import { CurrentCoursesCard } from './CurrentCourses';
import { EnrollmentReminderBanner } from './EnrollmentReminder';
import { UpcomingCoursesCard } from './UpcomingCourses';

type Props = { degreeMetadata: DegreeMetadata };

export const DegreeHomeV2: React.FunctionComponent<Props> = ({
  degreeMetadata: { id: degreeId, partnerIds, supportEmailAddress, supportLink },
}) => {
  const partnerId = partnerIds[0];
  return (
    <>
      <TabPanel value="home">
        <Grid container spacing={{ xs: 24, sm: 32 }}>
          <Grid item xs={12}>
            <EnrollmentReminderBanner degreeId={degreeId} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <UpcomingCoursesCard supportEmailAddress={supportEmailAddress} />
            <CurrentCoursesCard degreeId={degreeId} />
            <MobileCalendarCard degreeId={degreeId} />
            <RecentGradesCard degreeId={degreeId} />
            <SlackAccountInfoCard degreeId={degreeId} />
            <CalendarSyncCard />
            <SupportInfoCard
              degreeId={degreeId}
              supportEmailAddress={supportEmailAddress}
              partnerId={partnerId}
              supportLink={supportLink}
            />
          </Grid>

          <Grid item sm={6}>
            <CalendarCard degreeId={degreeId} />
          </Grid>
        </Grid>
      </TabPanel>
    </>
  );
};

export default DegreeHomeV2;
